/* MARMOT: продуктова страница (Порция #237). Vanilla, defer, без библиотеки.
   - Галерия: миниатюри, стрелки, плъзгане с пръст, клавиатура (← →) и
     лайтбокс с брояч и зуум. Целият нов markup се строи тук, за да важи и за
     страницата на комплекта, която ползва същия файл през същите data-pdp-* куки.
   - „Прочети откъс": отваря модал с Heyzine iframe (src се вписва при отваряне).
   - Количество: − / + степер; обновява прогреса за безплатна доставка.
   - Лепната долна лента: position:fixed + spacer (НЕ sticky – Lumia убива sticky).
     Показва се, след като купи-зоната излезе от екрана нагоре. */
(function () {
  'use strict';

  var root = document.querySelector('[data-marmot-pdp]');
  if (!root) return;

  /* Preview на типа корица без метаполе: ?mockup=soft|rounded|hard */
  try {
    var mk = new URLSearchParams(window.location.search).get('mockup');
    if (mk && /^(soft|rounded|hard)$/.test(mk)) {
      var cov = root.querySelector('.marmot-pdp__frame--cover');
      if (cov) cov.className = cov.className.replace(/is-mockup-\w+/, 'is-mockup-' + mk);
    }
  } catch (e) {}

  /* Изрязване на прозрачното поле около корицата (soft/rounded/hard).
     Файловете са квадратни с прозрачни полета; за реално заоблени ъгли трябва
     корицата да пълни рамката. Откриваме границите ѝ през алфа-канала (canvas),
     напасваме я да пълни рамката → CSS заобля реалните ѝ ъгли (overflow:hidden).
     Ползваме отделен crossorigin probe, за да не рискуваме показвания образ. */
  (function trimCover() {
    var frame = root.querySelector('.marmot-pdp__frame--cover');
    if (!frame || !/is-mockup-(soft|rounded|hard)/.test(frame.className)) return;
    var img = frame.querySelector('.marmot-pdp__media');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var w = probe.naturalWidth, h = probe.naturalHeight;
      if (!w || !h) return;
      var cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      var cx = cv.getContext('2d', { willReadFrequently: true });
      cx.drawImage(probe, 0, 0);
      var data;
      try { data = cx.getImageData(0, 0, w, h).data; } catch (e) { return; }
      var minX = w, minY = h, maxX = 0, maxY = 0, found = false, T = 12;
      for (var y = 0; y < h; y++) {
        var row = y * w;
        for (var x = 0; x < w; x++) {
          if (data[(row + x) * 4 + 3] > T) {
            found = true;
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (!found) return;
      var cw = maxX - minX + 1, ch = maxY - minY + 1;
      var s = frame.style;
      s.setProperty('--cov-ar', (cw / ch).toFixed(4));
      s.setProperty('--cov-w', (w / cw * 100).toFixed(3) + '%');
      s.setProperty('--cov-h', (h / ch * 100).toFixed(3) + '%');
      s.setProperty('--cov-x', '-' + (minX / cw * 100).toFixed(3) + '%');
      s.setProperty('--cov-y', '-' + (minY / ch * 100).toFixed(3) + '%');
      frame.classList.add('is-trimmed');
    };
    probe.onerror = function () { /* CORS/зареждане – оставяме fallback вида */ };
    probe.src = src;
  })();

  /* ── Галерия ──────────────────────────────────────────────────────────
     Работи по data-* куки, НИКОГА по `.marmot-pdp__media`: страницата на
     комплекта (sections/marmot-bundle.liquid) ползва същия този файл, но
     рамките ѝ са с други класове (`marmot-bundle__frame/__media`). Закачим
     ли се за класа на книгата, комплектът тихо остава без галерия.

     Стрелките, подсказката „лупа" и целият лайтбокс се СТРОЯТ тук, а не в
     Liquid – иначе същият markup трябва да живее в две секции и да се
     разминава. Цената: без JS галерията е една снимка, но тя и досега беше
     изцяло на JS (миниатюрите не работят без него). */
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
  var stage = root.querySelector('[data-pdp-stage]');
  var current = 0;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slideLabel(i) {
    var s = slides[i];
    if (!s) return '';
    return s.getAttribute('data-pdp-label') || ('кадър ' + (i + 1));
  }

  /* Циклично: след последната – първата и обратно. Изнесена е като чиста
     функция, за да може тестът да я пусне наистина, вместо да гледа низа. */
  function normIndex(idx, n) {
    if (!n) return 0;
    return ((idx % n) + n) % n;
  }

  function showSlide(idx, opts) {
    if (!slides.length) return;
    idx = normIndex(idx, slides.length);
    current = idx;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function (t) {
      var on = parseInt(t.getAttribute('data-pdp-thumb'), 10) === idx;
      t.classList.toggle('is-active', on);
      // aria-current, а не aria-pressed: това е „текущият кадър от поредица",
      // не превключвател.
      if (on) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
      if (on && opts && opts.scrollThumb) scrollThumbIntoView(t);
    });
    if (live) live.textContent = slideLabel(idx);
    if (lb && !lb.hidden) syncLightbox();
  }

  /* Активната миниатюра се докарва в полезрението на РЕДА. `block: 'nearest'`
     е задължителен – без него браузърът върти и вертикалния скрол и страницата
     подскача точно докато потребителят разлиства. */
  function scrollThumbIntoView(t) {
    var row = t.parentNode;
    try {
      if (t.scrollIntoView) {
        t.scrollIntoView({
          inline: 'center',
          block: 'nearest',
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        return;
      }
    } catch (e) {
      // Стар Safari не приема обектния подпис – пада на ръчното смятане долу.
    }
    // Резервно: центрираме ръчно, вместо да оставим потребителя да не вижда
    // коя миниатюра е избрана.
    if (row && row.scrollWidth > row.clientWidth) {
      row.scrollLeft = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showSlide(parseInt(t.getAttribute('data-pdp-thumb'), 10) || 0, { scrollThumb: true });
    });
  });

  /* ── Стрелки върху сцената + подсказка „лупа" ─────────────── */
  function arrowSvg(dir) {
    var d = dir < 0 ? 'm15 5-7 7 7 7' : 'm9 5 7 7-7 7';
    return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"'
      + ' stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="' + d + '"/></svg>';
  }

  /* Етикетът говори езика на страницата: на книга кадрите са „разтвори",
     на комплект – „кадри". Взима се от data-pdp-label на втория слайд, за да
     не се разминава с брояча и с alt текста. */
  function kadarDuma() {
    var s = slides.length > 1 ? slides[1] : null;
    var lbl = s ? (s.getAttribute('data-pdp-label') || '') : '';
    return lbl.indexOf('разтвор') === 0 ? 'разтвор' : 'кадър';
  }

  function makeArrow(dir, cls, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls + ' ' + cls + (dir < 0 ? '--prev' : '--next');
    b.setAttribute('aria-label', (dir < 0 ? 'Предишен ' : 'Следващ ') + kadarDuma());
    b.innerHTML = arrowSvg(dir);
    b.addEventListener('click', onClick);
    return b;
  }

  if (stage && slides.length > 1) {
    // Стрелките стоят върху сцената – затова родителят ѝ трябва да е позициониран.
    stage.appendChild(makeArrow(-1, 'marmot-pdp__nav', function (e) {
      e.stopPropagation();
      showSlide(current - 1, { scrollThumb: true });
    }));
    stage.appendChild(makeArrow(1, 'marmot-pdp__nav', function (e) {
      e.stopPropagation();
      showSlide(current + 1, { scrollThumb: true });
    }));
  }

  /* ── Клавиатура: ← → само когато галерията е на фокус ─────── */
  /* Смяната на кадър трябва да се чуе, не само да се види. */
  var live = null;
  if (stage && slides.length > 1) {
    live = document.createElement('span');
    live.className = 'marmot-vh';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('data-pdp-live', '');
    stage.appendChild(live);
  }

  if (stage && slides.length > 1) {
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('role', 'group');
    stage.setAttribute('aria-label', 'Галерия – стрелките сменят кадъра');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(current - 1, { scrollThumb: true }); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(current + 1, { scrollThumb: true }); }
    });
  }

  /* ── Плъзгане с пръст ─────────────────────────────────────────
     pointer събития, не touch: така работи и с писалка/мишка. Праг 40px И
     хоризонталното да е по-голямо от вертикалното – иначе жестът краде
     вертикалния скрол на страницата. Затова никъде няма preventDefault. */
  function addSwipe(el, onLeft, onRight) {
    if (!el || !window.PointerEvent) return;
    var x0 = 0, y0 = 0, id = null;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      id = e.pointerId; x0 = e.clientX; y0 = e.clientY;
      stageMoved = false;
    });
    el.addEventListener('pointerup', function (e) {
      if (id === null || e.pointerId !== id) return;
      id = null;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      // Всяко забележимо движение отменя клика: иначе скролът с пръст върху
      // снимката завършва с отваряне на лайтбокса.
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) stageMoved = true;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      if (dx < 0) onLeft(); else onRight();
    });
    el.addEventListener('pointercancel', function () { id = null; stageMoved = true; });
  }

  if (slides.length > 1) {
    addSwipe(stage,
      function () { showSlide(current + 1, { scrollThumb: true }); },
      function () { showSlide(current - 1, { scrollThumb: true }); });
  }

  /* ── Лайтбокс ─────────────────────────────────────────────────
     Строи се веднъж, при първо отваряне. Големият файл (data-pdp-full, 2048px)
     се задава на `src` чак тогава – затова зареждането на страницата не тегли
     всички разтвори в голям размер. */
  var lb = null, lbImg = null, lbCount = null, lbLastFocus = null;
  var zoomed = false, panX = 0, panY = 0, justDragged = false;
  var stageMoved = false, prevOverflow = '';

  function hasLightbox() {
    return slides.some(function (s) { return s.getAttribute('data-pdp-full'); });
  }

  function buildLightbox() {
    lb = document.createElement('div');
    lb.className = 'marmot-pdp__lb';
    // Комплект: снимката е банер – в лайтбокса със същите заоблени ъгли като на страницата.
    if (root.classList.contains('marmot-bundle') || root.classList.contains('marmot-pdp--banner')) {
      lb.classList.add('marmot-pdp__lb--banner');
    }
    lb.setAttribute('data-pdp-lightbox', '');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Уголемен изглед');
    lb.hidden = true;
    lb.innerHTML =
      '<div class="marmot-pdp__lb-backdrop" data-pdp-lb-close></div>'
      + '<figure class="marmot-pdp__lb-stage">'
      + '<img class="marmot-pdp__lb-img" alt="" decoding="async">'
      + '</figure>'
      + '<div class="marmot-pdp__lb-count" data-pdp-lb-count aria-live="polite"></div>'
      + '<button type="button" class="marmot-pdp__lb-close" data-pdp-lb-close aria-label="Затвори">'
      + '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"'
      + ' stroke-width="2.2" stroke-linecap="round" aria-hidden="true">'
      + '<path d="m6 6 12 12M18 6 6 18"/></svg></button>';

    lbImg = lb.querySelector('.marmot-pdp__lb-img');
    lbCount = lb.querySelector('[data-pdp-lb-count]');

    if (slides.length > 1) {
      lb.appendChild(makeArrow(-1, 'marmot-pdp__lb-nav', function (e) {
        e.stopPropagation(); showSlide(current - 1, { scrollThumb: true });
      }));
      lb.appendChild(makeArrow(1, 'marmot-pdp__lb-nav', function (e) {
        e.stopPropagation(); showSlide(current + 1, { scrollThumb: true });
      }));
      addSwipe(lb.querySelector('.marmot-pdp__lb-stage'),
        function () { if (!zoomed) showSlide(current + 1, { scrollThumb: true }); },
        function () { if (!zoomed) showSlide(current - 1, { scrollThumb: true }); });
    }

    // Затваряне: бутонът и фонът. Кликът върху самата снимка е зуум, не затваряне.
    lb.querySelectorAll('[data-pdp-lb-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    lbImg.addEventListener('click', toggleZoom);
    addPan(lbImg);

    /* Капан за фокуса: без него Tab извежда потребителя в скритата зад
       лайтбокса страница, а `aria-modal` обещава обратното. */
    lb.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = lb.querySelectorAll('button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // P2.3: старата снимка не бива да стои под новия брояч, докато новата се тегли.
    lbImg.addEventListener('load', function () {
      lbImg.classList.remove('is-loading');
      lbImg.classList.toggle('is-zoomable', canZoom());
    });

    document.body.appendChild(lb);
  }

  function syncLightbox() {
    if (!lb) return;
    var s = slides[current];
    var full = s ? s.getAttribute('data-pdp-full') : '';
    var inner = s ? s.querySelector('img') : null;
    resetZoom();
    /* Липсва ли голям файл (рамка без снимка), СВАЛЯМЕ src – иначе под новия
       брояч и новия alt остава да виси предишната снимка. */
    if (full) {
      if (lbImg.getAttribute('src') !== full) lbImg.classList.add('is-loading');
      lbImg.setAttribute('src', full);
    } else {
      lbImg.removeAttribute('src');
      lbImg.classList.remove('is-loading');
    }
    lbImg.setAttribute('alt', (inner && inner.getAttribute('alt')) || slideLabel(current));
    if (lbCount) lbCount.textContent = (current + 1) + ' / ' + slides.length;
  }

  function openLightbox() {
    if (!hasLightbox()) return;
    if (!lb) buildLightbox();
    lbLastFocus = document.activeElement;
    syncLightbox();
    lb.hidden = false;
    /* Заключваме скрола, но помним какво е било: `html.marmot-menu-open` също
       слага overflow: hidden и връщането на празен низ би отключило чужда
       ключалка. */
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = lb.querySelector('.marmot-pdp__lb-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    if (!lb || lb.hidden) return;
    resetZoom();
    lb.hidden = true;
    document.documentElement.style.overflow = prevOverflow;
    if (lbLastFocus && lbLastFocus.focus) lbLastFocus.focus();
  }

  /* Зуум: „побрана" ↔ „реален размер". Реалният размер идва от naturalWidth –
     оригиналите на разтворите са ~1890px, тоест зуумът е умерен, не безкраен.
     На тъч устройства не пипаме нищо: pinch-zoom на браузъра върши работа и
     собствен зуум само би му пречил. */
  function canZoom() {
    if (!lbImg || !lbImg.naturalWidth) return false;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return false;
    return lbImg.naturalWidth > lbImg.clientWidth + 8;
  }

  function applyZoom() {
    if (!lbImg) return;
    if (!zoomed) {
      lbImg.style.transform = '';
      return;
    }
    var k = lbImg.naturalWidth / lbImg.clientWidth;
    lbImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + k + ')';
  }

  function resetZoom() {
    zoomed = false; panX = 0; panY = 0;
    if (lbImg) {
      lbImg.style.transform = '';
      lbImg.classList.remove('is-zoomed');
    }
  }

  /* Зуумът се смята от clientWidth. Смени ли се прозорецът (или се завърти
     таблетът), старият коефициент изкарва снимката извън рамката. */
  window.addEventListener('resize', function () {
    if (lb && !lb.hidden) {
      if (zoomed) { panX = 0; panY = 0; applyZoom(); }
      if (lbImg) lbImg.classList.toggle('is-zoomable', canZoom());
    }
  });

  function toggleZoom() {
    // Влачене ≠ клик: без този изход всяко местене на зуумната снимка щеше да
    // я връща в „побрана" в момента, в който потребителят пусне показалеца.
    if (justDragged) { justDragged = false; return; }
    if (!canZoom() && !zoomed) return;
    zoomed = !zoomed;
    panX = 0; panY = 0;
    lbImg.classList.toggle('is-zoomed', zoomed);
    applyZoom();
  }

  /* Влачене за местене, докато е зуумнато. */
  function addPan(el) {
    if (!window.PointerEvent) return;
    var dragging = false, sx = 0, sy = 0, bx = 0, by = 0;
    el.addEventListener('pointerdown', function (e) {
      if (!zoomed) return;
      dragging = true; justDragged = false;
      sx = e.clientX; sy = e.clientY; bx = panX; by = panY;
      if (el.setPointerCapture) el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      panX = bx + (e.clientX - sx);
      panY = by + (e.clientY - sy);
      applyZoom();
    });
    el.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      if (el.releasePointerCapture) el.releasePointerCapture(e.pointerId);
      justDragged = (Math.abs(e.clientX - sx) > 4 || Math.abs(e.clientY - sy) > 4);
    });
  }

  /* Отваряне: клик върху сцената + подсказката „лупа". */
  if (stage && hasLightbox()) {
    stage.classList.add('is-zoomable');
    stage.addEventListener('click', function (e) {
      // Стрелките и бутонът „Прочети откъс" не отварят лайтбокса.
      if (e.target.closest('button')) return;
      // Празното поле около кадъра също не отваря: сцената е по-широка от
      // корицата и иначе кликът „встрани от книгата" изненадва.
      if (!e.target.closest('[data-pdp-slide]')) return;
      // Скрол с пръст завършва с click – ако е имало движение, не отваряме.
      if (stageMoved) { stageMoved = false; return; }
      openLightbox();
    });

    var hint = document.createElement('button');
    hint.type = 'button';
    hint.className = 'marmot-pdp__zoom-hint';
    hint.setAttribute('aria-label', 'Отвори снимката голяма');
    hint.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"'
      + ' stroke-width="2" stroke-linecap="round" aria-hidden="true">'
      + '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8.5v5M8.5 11h5"/></svg>';
    hint.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(); });
    stage.appendChild(hint);
  }

  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(current - 1, { scrollThumb: true }); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(current + 1, { scrollThumb: true }); }
  });

  showSlide(0);

  /* ── Количество + прогрес за доставка ─────────────────── */
  var priceEl = root.querySelector('[data-pdp-price]');
  var shipEl = root.querySelector('[data-pdp-ship]');
  var qtyInput = root.querySelector('[data-pdp-qty-input]');
  var variantSel = root.querySelector('[data-pdp-variant]');

  function unitCents() {
    if (variantSel) {
      var opt = variantSel.options[variantSel.selectedIndex];
      if (opt && opt.getAttribute('data-cents')) return parseInt(opt.getAttribute('data-cents'), 10) || 0;
    }
    return priceEl ? (parseInt(priceEl.getAttribute('data-unit-cents'), 10) || 0) : 0;
  }
  function qty() {
    var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return (isNaN(q) || q < 1) ? 1 : q;
  }
  function updateShip() {
    if (!shipEl) return;
    var goal = parseInt(shipEl.getAttribute('data-goal-cents'), 10) || 3000;
    var goalLabel = shipEl.getAttribute('data-goal-label') || ((goal / 100) + ' €');
    var line = unitCents() * qty();
    var pct = Math.min(100, Math.round((line / goal) * 100));
    var fill = shipEl.querySelector('[data-pdp-ship-fill]');
    var lblEl = shipEl.querySelector('[data-pdp-ship-label]');
    if (fill) fill.style.width = pct + '%';
    // Уточнението „(преди отстъпки)" стои само на реда, който обявява правилото
    // с числото; достигнатият праг не го влачи (решение 09.08.2026).
    if (lblEl) lblEl.textContent = pct >= 100
      ? 'Имаш безплатна доставка 🎉'
      : 'Безплатна доставка от ' + goalLabel + ' (преди отстъпки)';
  }
  var dec = root.querySelector('[data-pdp-qty-dec]');
  var inc = root.querySelector('[data-pdp-qty-inc]');
  if (dec) dec.addEventListener('click', function () {
    if (qtyInput) { qtyInput.value = Math.max(1, qty() - 1); updateShip(); }
  });
  if (inc) inc.addEventListener('click', function () {
    if (qtyInput) { qtyInput.value = qty() + 1; updateShip(); }
  });
  if (qtyInput) qtyInput.addEventListener('input', updateShip);
  if (variantSel) variantSel.addEventListener('change', updateShip);

  /* ── Лепната долна лента: fixed + spacer ──────────────── */
  var bar = document.querySelector('[data-pdp-bar]');
  var buy = root.querySelector('[data-pdp-buy]');
  var spacer = null;
  if (bar && buy) {
    bar.hidden = false;

    function ensureSpacer() {
      if (spacer) return;
      spacer = document.createElement('div');
      spacer.setAttribute('data-pdp-bar-spacer', '');
      spacer.style.height = bar.offsetHeight + 'px';
      bar.parentNode.insertBefore(spacer, bar);
    }
    function toggleBar() {
      var r = buy.getBoundingClientRect();
      // Показвай, след като дъното на купи-зоната мине над екрана.
      var show = r.bottom < 90;
      if (show) { ensureSpacer(); }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();

    // Бутонът в лентата = submit на основната форма.
    var barAdd = bar.querySelector('[data-pdp-bar-add]');
    var form = root.querySelector('[data-pdp-form]');
    if (barAdd && form) {
      barAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* ── Модал „Прочети откъс" ────────────────────────────── */
  var modal = document.querySelector('[data-pdp-modal]');
  var openBtn = root.querySelector('[data-pdp-excerpt-open]');
  if (modal && openBtn) {
    var iframe = modal.querySelector('[data-pdp-flip-src]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      if (iframe && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.getAttribute('data-pdp-flip-src'));
      }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-pdp-modal-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-pdp-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  updateShip();
})();
